import React, { useRef, useState, useContext, Fragment } from 'react';
import SingleVideoSlide from './singleVideoSlide';
import Carousel from '../../components/carousel';
import PageContext from '../../contexts/pageContext';

import useVideoTestimonialStyles from './styles';

function VideoTestimonial({ sectionData, sectionIndex }) {
  const {
    layout: { containerWidth },
    countryCode,
    currencySymbol,
    isMobile
  } = useContext(PageContext);
  const classes = useVideoTestimonialStyles({ containerWidth, isMobile });
  const [videoData] = sectionData.components;
  const Wrapper =
    videoData.videoCarousel.components.length > 1 ? Carousel : Fragment;

  return (
    <div className={classes.videoTestimonialSuperContainer}>
      <div className={classes.videoTestimonialContainer}>
        <div className={classes.sectionContainer}>
          <div className={classes.videoTestimonialHeading}>
            <span
              ref={videoData?.videoHeading?.refSetter}
              dangerouslySetInnerHTML={{
                __html: videoData.videoHeading.metadata.value
              }}
            />
          </div>
          <h2 className={classes.videoTestimonialTitle}>
            <span
              ref={videoData?.title?.refSetter}
              dangerouslySetInnerHTML={{
                __html: videoData.title.metadata.value
              }}
            />
          </h2>
          <Wrapper>
            {videoData.videoCarousel.components.map((data, index) => (
              <SingleVideoSlide
                data={data}
                key={index}
                sectionIndex={sectionIndex}
                countryCode={countryCode}
                currencySymbol={currencySymbol}
              />
            ))}
          </Wrapper>
        </div>
      </div>
    </div>
  );
}

export default VideoTestimonial;
